import { Button } from "components";
import classnames from "classnames";
import { ReactNode } from "react";

interface BadgeToggleProps {
  variant?:
    | "solid"
    | "bordered"
    | "light"
    | "flat"
    | "faded"
    | "shadow"
    | "ghost";
  icon?: ReactNode;
  label?: string;
  isActive?: boolean;
  onToggleChange?: () => void;
  className?: string;
  radius?: "none" | "sm" | "md" | "lg" | "full";
  isSelectedClassName?: string;
  isNotSelectedClassName?: string;
}

const buttonStyles = (
  isSelected: boolean,
  className?: string,
  isSelectedClassName?: string,
  isNotSelectedClassName?: string,
) =>
  classnames(className, {
    "w-full h-fit flex items-center px-2 py-2 gap-1! rounded-md": !className,
    [isSelectedClassName || ""]: isSelected,
    [isNotSelectedClassName || ""]: !isSelected,
  });

export const BadgeToggle = ({
  variant,
  icon,
  label,
  isActive = false,
  onToggleChange,
  className,
  radius,
  isSelectedClassName = "border-2 bg-white border-moss-primary text-moss-primary font-medium",
  isNotSelectedClassName = "border border-neutral-primary/20 bg-white text-neutral-primary",
}: BadgeToggleProps) => {
  return (
    <Button
      radius={radius}
      variant={!isActive ? variant : "solid"}
      isIconOnly
      className={classnames(
        buttonStyles(
          isActive,
          className,
          isSelectedClassName,
          isNotSelectedClassName,
        ),
        "overflow-hidden",
      )}
      onClick={onToggleChange}
    >
      {icon && icon}
      {label && <span className="whitespace-normal break-words">{label}</span>}
    </Button>
  );
};
